import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  text-align: ${props => props.align || 'left'};
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: ${props => props.fontSize || '42px'};
  font-weight: ${props => props.fontWeight || '800'};
  color: ${props => props.color || 'var(--text-primary)'};
  line-height: 1.2;
  margin: 0;
  font-family: var(--font, sans-serif);
`;

const Badge = styled.div`
  display: inline-block;
  background: rgba(6,182,212,0.15);
  color: var(--accent);
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
  border: 1px solid rgba(6,182,212,0.3);
`;

const PostTitleWidget = ({ node }) => {
  const isDynamic = node.content?.isDynamic !== false;
  const fallbackText = node.content?.fallbackText || 'Dynamischer Beitrags-Titel';
  const displayCategory = node.content?.displayCategory !== false;

  const align = node.style?.desktop?.align || 'left';
  const fontSize = node.style?.desktop?.fontSize || '42px';
  const color = node.style?.desktop?.color || '';

  return (
    <Wrapper width={node.style?.desktop?.width} align={align}>
      {displayCategory && <Badge>News & Updates</Badge>}
      <Title fontSize={fontSize} color={color}>
        {isDynamic ? '{post_title}' : fallbackText}
      </Title>
    </Wrapper>
  );
};

registry.register('post_title', {
  label: 'Post Titel (Dyn.)',
  icon: '🅰️',
  category: 'dynamic',
  defaultContent: {
    isDynamic: true,
    fallbackText: 'Dein Titel hier',
    displayCategory: true
  },
  defaultStyle: {
    desktop: { align: 'left', fontSize: '42px', width: '100%' }
  },
  render: PostTitleWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Datenquelle',
          fields: [
            { name: 'content.isDynamic', label: 'Dynamisch aus DB laden?', type: 'select', options: [{label:'Ja', value:true}, {label:'Nein (Manuell)', value:false}] },
            { name: 'content.fallbackText', label: 'Manueller Text', type: 'text' },
            { name: 'content.displayCategory', label: 'Kategorie Tag anzeigen', type: 'select', options: [{label:'Ja', value:true}, {label:'Nein', value:false}] }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Typografie',
          fields: [
            { name: 'style.desktop.fontSize', label: 'Größe (z.B. 42px)', type: 'text' },
            { name: 'style.desktop.color', label: 'Farbe (CSS/Hex)', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}] }
          ]
        }
      ]
    }
  ]
});
